import InternetCut from "./InternetCut";
export default InternetCut;
